import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BottomTabNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: 'Home',
      icon: 'Home',
      route: '/home-feed',
      notificationCount: 0,
    },
    {
      label: 'Create',
      icon: 'PlusSquare',
      route: '/create-post',
      notificationCount: 0,
    },
    {
      label: 'Profile',
      icon: 'User',
      route: '/user-profile',
      notificationCount: 3,
    },
  ];

  const handleTabClick = (route) => {
    navigate(route);
  };

  const isActive = (route) => {
    return location?.pathname === route;
  };

  return (
    <nav className="bottom-tab-navigation">
      <div className="bottom-tab-navigation-container">
        {tabs?.map((tab) => (
          <button
            key={tab?.route}
            onClick={() => handleTabClick(tab?.route)}
            className={`bottom-tab-item ${isActive(tab?.route) ? 'active' : 'inactive'}`}
            aria-label={tab?.label}
            aria-current={isActive(tab?.route) ? 'page' : undefined}
          >
            <div className="relative">
              <Icon
                name={tab?.icon}
                size={24}
                strokeWidth={isActive(tab?.route) ? 2.5 : 2}
              />
              {tab?.notificationCount > 0 && (
                <span className="notification-badge">
                  {tab?.notificationCount > 99 ? '99+' : tab?.notificationCount}
                </span>
              )}
            </div>
            <span className="bottom-tab-label">{tab?.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomTabNavigation;